import React from "react"

import {H1} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {RedemptionReportDuration} from "@irati/types"

import {useUserSavings} from "@irati/adminReporting/hooks"
import mySavings from "@irati/ui/images/mySavings.svg"
import Loading from "@irati/ui/src/Loading"
import RedemptionTable from "../components/SavingsTracker/RedemptionTable"

interface Props extends InjectIntl {}

const MySavings = ({formatMessage}: Props) => {
  const {data, load} = useUserSavings({month: undefined, duration: RedemptionReportDuration.AllTime})
  if (!data) return null

  return (
    <Loading load={load}>
      <Flex alignItems="center" gap={0.5} marginTop={5} marginBottom={4}>
        <img src={mySavings} alt="" />
        <H1>
          <FormattedMessage id="platform.mySavings.header.copy" />
        </H1>
      </Flex>
      <RedemptionTable brands={data.brands} currency={data.savings?.fixed?.currency} />
    </Loading>
  )
}

export default injectIntl(MySavings)
